<!--
 * @Description:
 * @Date: 2020-07-16 17:20:37
-->
<template>
  <div
    class="bi"
    id="bi"
    :style="{ position: localQuery.isAutoExport ? 'fixed' : '', 'z-index': -2 }"
  >
    <div class="bi-title">
      <p class="bi-title-p">统计报表</p>
      <div class="bi-title-handle">
        <!-- <el-button
          style="font-size:16px"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
        >返回</el-button>-->
        <div>
          <!-- <el-button
            style="width:100px"
            size="small"
            type="primary"
            plain
            @click="fullPage()"
            :loading="loading"
          >
            {{fullscreen?'退出全屏':'进入全屏'}}
            <i class="el-icon-rank el-icon--right"></i>
          </el-button>-->
          <el-button
            style="width:90px"
            size="small"
            type="primary"
            @click="handlerExport('pdf')"
            :loading="loading"
          >
            导出PDF
            <i class="el-icon-download el-icon--right" v-if="!loading"></i>
          </el-button>
          <!-- <el-button
            style="width:90px"
            size="small"
            type="warning"
            @click="handlerExport('png')"
            :loading="loading"
          >
            导出图片
            <i class="el-icon-download el-icon--right" v-if="!loading"></i>
          </el-button>
          <el-button
            style="width:110px"
            size="small"
            type="success"
            @click="handlerExportAll()"
            :loading="loading"
          >
            导出项目详情
            <i class="el-icon-download el-icon--right"></i>
          </el-button> -->
        </div>
      </div>
    </div>
    <div
      style="width:1200px;position:fixed;z-index:-2;transform-origin: 0 0;"
      id="bi-export-cache"
    ></div>
    <div id="bi-export">
      <div class="bi-export-content">
        <div style="padding-top:80px;text-align:left;">
          <img :src="logo" alt width="344" height="26" />
        </div>
        <Header class="bi-export-item" :obj="headerData"></Header>
        <Combination :combinationData="combinationData"></Combination>
        <div>
          <Item
            class="bi-export-item"
            v-for="(val, key, index) in items.data"
            :itemIndex="index"
            :key="key"
            v-bind="val"
          ></Item>
        </div>
        <Footer class="bi-export-item" style="margin-top:68px;"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import Combination from './components/Combination';

import Item from './components/Item';
import { BI } from '@/api/ajax';
import serviceIndex from './service/index';
import htmlToPdf from '@/tools/htmlToPdf';
import receiptDownload from './tools/receiptDownload';
import { downloadFile } from '@/tools/index';

export default {
  provide() {
    return {
      query: this.query,
      items: this.items
    };
  },
  data() {
    return {
      logo:
        'data:image/png;base64,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',
      query: {
        data: null
      },
      items: { data: {} },
      combinationData: {},
      loading: false,
      headerData: {},
      fullscreen: false
    };
  },
  props: {
    localQuery: {
      type: Object,
      default: () => ({})
    }
  },
  components: { Header, Footer, Item, Combination },
  watch: {},
  computed: {},
  methods: {
    fullPage() {
      const { fullscreen } = this;
      const docElm = fullscreen ? document : document.documentElement;
      const fn = fullscreen
        ? docElm.exitFullscreen ||
          docElm.mozCancelFullScreen ||
          docElm.webkitCancelFullScreen
        : docElm.requestFullscreen ||
          docElm.mozRequestFullScreen ||
          docElm.webkitRequestFullScreen;
      fn &&
        fn.apply(docElm).then(() => {
          this.fullscreen = !fullscreen;
        });
    },
    async handlerExportAll() {
      this.loading = true;
      const msgBox = this.$message({
        duration: 0,
        message: '正在生成数据报表，请您稍等。'
      });
      const name = `${(this.headerData || {}).projectName}服务报告`.replace(
        / /g,
        ''
      );
      setTimeout(() => {
        Promise.all([
          htmlToPdf.generate('#bi-export', 'pdf', name),
          htmlToPdf.generate('#bi-export', 'png', name)
        ]).then(res => {
          Promise.all(
            res.reduce((pre, cur, index) => {
              const formData = new FormData();
              formData.append('file', cur);
              formData.append('suffix', `${name}.${['pdf', 'png'][index]}`);
              pre.push(BI.common.fileUpload(formData));
              return pre;
            }, [])
          ).then(_res => {
            const [pdfRes, pngRes] = _res;
            receiptDownload.call(this, {
              data: {
                projectId: (this.headerData || {}).projectId,
                taskDt: (this.headerData || {}).taskDt,
                downloadPngUrl: pngRes.data.data.fileUrl,
                downloadUrl: pdfRes.data.data.fileUrl,
                fileSize: pngRes.data.data.fileSize + pdfRes.data.data.fileSize
              },
              ajax: BI.common.addPdf2TaskDownload,
              projectName: name
            });
            msgBox.close();
            this.loading = false;
          });
        });
      }, 500);
    },
    async handlerExport(type) {
      this.loading = true;
      const msgBox = this.$message({
        duration: 0,
        message: '正在生成数据报表，请您稍等。'
      });
      const name = `${(this.headerData || {}).projectName}服务报告`.replace(
        / /g,
        ''
      );
      // const elName = type === 'pdf' ? '.bi-export-item' : '#bi-export';
      const elName = type === 'pdf' ? '#bi-export' : '#bi-export';
      setTimeout(() => {
        htmlToPdf.generate(elName, type, name).then(async res => {
          const formData = new FormData();
          formData.append('file', res);
          formData.append('suffix', `${name}.${type}`);
          const {
            data: {
              data: { fileSize, fileUrl }
            }
          } = await BI.common.fileUpload(formData);
          this.loading = false;
          msgBox.close();
          const params = {
            projectId: (this.headerData || {}).projectId,
            taskDt: (this.headerData || {}).taskDt,
            fileSize: fileSize,
            downloadUrl: '',
            downloadPngUrl: ''
          };
          params[type == 'pdf' ? 'downloadUrl' : 'downloadPngUrl'] = fileUrl;
          receiptDownload.call(this, {
            data: params,
            ajax: ({ downloadName }) => {
              downloadFile(`${downloadName}.${type}`, fileUrl);
            },
            projectName: name,
            tips: '下载成功'
          });
          // this.$message({
          //   message: '报表已导出，请您注意浏览器提示。',
          //   type: 'success'
          // });
        });
      }, 500);
    },
    async autoHandlerExport(type = 'pdf') {
      return new Promise((resolve, reject) => {
        this.loading = true;
        const name = `${(this.headerData || {}).projectName}服务报告`.replace(
          / /g,
          ''
        );
        // const elName = type === 'pdf' ? '.bi-export-item' : '#bi-export';
        const elName = type === 'pdf' ? '#bi-export' : '#bi-export';
        setTimeout(() => {
          htmlToPdf.generate(elName, type, name).then(async res => {
            const formData = new FormData();
            formData.append('file', res);
            formData.append('suffix', `${name}.${type}`);
            try {
              const {
                data: {
                  data: { fileSize, fileUrl }
                }
              } = await BI.common.fileUpload(formData);
              this.remove();
              resolve({
                fileSize,
                fileUrl
              });
            } catch (error) {
              reject('autoHandlerExport fail');
            }
          });
        }, 500);
      });
    }
  },
  async created() {
    const loading = this.$loading();
    this.query.data = {
      ...(this.$route ? this.$route.query : {}),
      ...this.localQuery
    };
    this.query.data['fenpeiIdArr'] = `${this.query.data['fenpeiIdArr']}`
      .split(',')
      .map(item => +item);
    this.query.data['projectId'] = +this.query.data['projectId'];
    try {
      // 获取头数据
      let {
        data: { data: queryProjectBaseInfo }
      } = await BI.common.queryProjectBaseInfo(this.query.data);
      this.headerData = queryProjectBaseInfo;
      this.query.data.authType = queryProjectBaseInfo.authType;
      // 获取内容数据
      let items = await serviceIndex[this.query.data.serviceType].run(
        this.query.data
      );
      let midObj = {};
      let midCombination = {};
      let loopIndex = 0;
      let loopData = data => {
        data.forEach(item => {
          if (Array.isArray(item)) {
            loopData(item);
          } else {
            if (['age', 'gender', 'audit', 'implement'].includes(item.key)) {
              midCombination[item.key] = item.value;
            } else {
              if (
                [0, 1].includes(queryProjectBaseInfo.authType) &&
                item.key === 'querytaskImgs'
              ) {
              } else {
                if (!item.value.header.hideHeader) {
                  loopIndex += 1;
                }
                item.value.header.index = loopIndex;
                midObj[item.key] = item.value;
              }
            }
          }
        });
      };
      loopData(items);
      this.$set(this, 'combinationData', midCombination);
      this.$set(this.items, 'data', midObj);
      this.$nextTick(() => {
        loading.close();
        if (this.localQuery.isAutoExport && this.localQuery.callback) {
          // 自动导出
          this.autoHandlerExport().then(res => {
            this.localQuery.callback(res);
          });
        }
      });
    } catch (e) {
      console.warn(e);
      this.$message({
        message: '数据加载错误，请刷新重试',
        type: 'error'
      });
    }
  },
  mounted() {
    const self = this;
    document.addEventListener('fullscreenchange', function() {
      self.fullscreen = document.fullscreenElement;
    });
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
@import '~@/styles/mixin.scss';
.bi-text-block {
  border: 1px solid rgba($color: #333, $alpha: 0.14);
  padding: 20px 30px;
  position: relative;
  &::before {
    content: '';
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    border: 1px solid rgba($color: #333, $alpha: 0.14);
    pointer-events: none;
    @include absolute_mid();
  }
  & > p {
    font-size: 14px;
    color: #222426;
    &:first-child {
      font-weight: bold;
    }
  }
}
</style>
<style scoped lang="scss">
@import '~@/styles/mixin.scss';
$width: 920px;
.box {
  background: #fff;
  padding: 24px 30px;
  border-radius: 4px;
  max-width: 1200px;
}
#bi-export {
  width: 100%;
  min-width: 1200px;
  padding-bottom: 100px;
  .bi-export-content {
    width: 920px;
    // transform: translateX(140px);
    overflow: hidden;
    margin: auto;
  }
}

.bi {
  margin: auto;
  max-width: 1200px;
  background-color: #f7fbff;
  text-align: center;
  &::before {
    content: '';
    background-color: #f7fbff;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
  }
  &-title {
    padding-top: 70px;
    &-p {
      font-size: 20px;
      font-weight: 500;
      padding-left: 12px;
      position: relative;
      text-align: left;
      color: #333;
      cursor: default;
      &:before {
        content: ' ';
        width: 4px;
        height: 19px;
        background: #3f89f2;
        left: 0;
        @include absolute_mid('y');
      }
    }
    &-handle {
      @extend .box;
      margin-top: 0;
      padding: 0;
      background: transparent;
      // margin-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      transform: translateY(-10px);
      .el-icon--right {
        margin-left: 0;
      }
    }
  }
}
</style>
